import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter4() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          This hyperconverged architecture combines robust server hardware with a suite of software
          solutions that create a single pool of virtualized compute-and-storage resources,
          streamlining access to every point of data and putting them at the fingertips of farmers
          and executives alike across the company’s expansive operation.
        </p>
      </section>
      <PullQuote
        quote={
          '“The perishable nature of our product means that we cannot afford any business system downtime whatsoever,” Oliveri explains. “We need an operations infrastructure that can guarantee 24/7 platform availability and a high degree of scalability.”'
        }
        color={'brown'}
      />
      <section className="chapter">
        <p className="chapter__paragraph">
          In an offsite location, backup Lenovo ThinkAgile servers don’t just offer redundant data
          security. They allow Perfection to scale the system up on demand without incurring any
          operational downtime – a highly adaptable and resilient operations infrastructure that
          simply keeps Perfection growing.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
